"use client"

import clsx from "clsx"
import { twMerge } from "tailwind-merge"

import { Box, H4, Markdown } from "@bullseye/components"

type Props = {
  description?: string
}

export const ActivityDescription = ({ description = "" }: Props) => {
  return (
    <Box
      className={twMerge(
        "flex flex-col rounded-none bg-white p-6 g-4 md:rounded-lg",
        clsx({
          hidden: !description,
        }),
      )}
    >
      <H4>Activity details</H4>
      {description && <Markdown content={description} />}
    </Box>
  )
}
